namespace $.$$ {

	$mol_style_define( $shm_tests_benchmarks, {

		flex: {
			grow: 1,
			basis: '40rem',
		},
		minWidth: 0,

		Body_content: {
			flex: {
				direction: 'column',
			},
			padding: $mol_gap.block,
		},

	} )

}
